// ======================================================================
// File: rfqService.js
// Module: PPE → Procurement → RFQ
//
// Purpose:
// - Handle all RFQ related API calls
// - Follow exact pattern of purchaseRequestService.js
// - No UI logic
// - No state handling
//
// Backend base path:
// /api/ppe/material-flow/rfq
// ======================================================================

import axiosClient from "../../../../../../api/axiosClient";

const BASE_URL = "/api/ppe/material-flow/rfq";

const rfqService = {

  // ==============================================================
  // GET APPROVED PRs FOR RFQ CREATION
  // ==============================================================
  getApprovedPRs(params = {}) {
    return axiosClient.get(`${BASE_URL}/approved-prs`, { params });
  },

  // ==============================================================
  // CREATE RFQ FROM PR
  // ==============================================================
  createRFQ(payload) {
    return axiosClient.post(`${BASE_URL}/create-from-pr`, payload);
  },

  // ==============================================================
  // LIST RFQs
  // ==============================================================
  getRFQs(params = {}) {
    return axiosClient.get(BASE_URL, { params });
  },

  // ==============================================================
  // GET RFQ DETAIL BY ID
  // ==============================================================
  getRFQById(rfqId) {
    return axiosClient.get(`${BASE_URL}/${rfqId}`);
  },

  // ==============================================================
  // ADD VENDORS TO RFQ
  // ==============================================================
  addVendorsToRFQ(rfqId, vendorIds = []) {
    return axiosClient.post(`${BASE_URL}/${rfqId}/vendors`, {
      vendor_ids: vendorIds,
    });
  },

  // ==============================================================
  // UI WRAPPER FOR MAPPING VENDORS
  // (Used by SendRFQDrawer.jsx)
  // ==============================================================
  mapVendors(payload) {
    return axiosClient.post(
      `${BASE_URL}/${payload.rfq_id}/vendors`,
      {
        vendor_ids: payload.vendor_ids,
      }
    );
  },

  // ==============================================================
  // SEND RFQ TO VENDORS
  // ==============================================================
  sendRFQ(rfqId) {
    return axiosClient.post(`${BASE_URL}/${rfqId}/send`);
  },

  // ==============================================================
  // GENERATE COMPARISON FOR RFQ
  // ==============================================================
  getComparison(rfqId) {
    return axiosClient.get(`${BASE_URL}/${rfqId}/compare`);
  },

  // ==============================================================
  // FINALIZE SELECTED VENDOR
  // ==============================================================
  finalizeVendor(rfqId, vendorId) {
    return axiosClient.post(`${BASE_URL}/${rfqId}/finalize`, {
      vendor_id: vendorId,
    });
  },

    // ==============================================================
    // GET RFQ VENDORS
    // ==============================================================
    getRFQVendors(rfqId) {
      return axiosClient.get(
        `${BASE_URL}/${rfqId}/vendors`
      );
    },

    // ==============================================================
    // GET QUOTE ENTRY DATA
    // ==============================================================
    getQuoteEntryData(
      rfqId,
      vendorId
    ) {
      return axiosClient.get(
        `${BASE_URL}/${rfqId}/vendor/${vendorId}`
      );
    },

    // ==============================================================
    // RFQs AVAILABLE FOR INTERNAL QUOTE ENTRY
    // ==============================================================
    getQuoteEntryRFQs() {
      return axiosClient.get(
        `${BASE_URL}/quote-entry/rfqs`
      );
    },

    submitInternalQuote(rfqId, vendorId, quotes) {
  return axiosClient.post(
    `${BASE_URL}/${rfqId}/vendor/${vendorId}/submit`,
    {
      quotes
    }
  );
},
  // ==============================================================
  // PUBLIC APIs – TOKEN BASED VENDOR PORTAL
  // ==============================================================

  validateToken(token) {
    return axiosClient.get(`${BASE_URL}/public/validate-token`, {
      params: { token }
    });
  },

  getRFQByToken(token) {
    return axiosClient.get(`${BASE_URL}/public/details`, {
      params: { token }
    });
  },

  submitQuoteByToken(payload) {
    return axiosClient.post(`${BASE_URL}/public/submit`, payload);
  },

};

export default rfqService;
